import { Box, CircularProgress, Tooltip } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { SearchByEnum } from 'enums/searchByEnum';
import React, { ChangeEvent, Fragment, PureComponent } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { SearchInputButton, SearchInputTextField } from './AddManyContentSearch.styled';

interface IProps {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  spinner?: boolean;
  value: string;
  searchBy: SearchByEnum;
  onSearchByChange: (searchBy: SearchByEnum) => () => void;
}

class AddManyContentSearch extends PureComponent<IProps & WithTranslation> {
  render(): JSX.Element {
    const { value, onChange, spinner, t, searchBy, onSearchByChange } = this.props;
    const error = value !== '' && !spinner && value?.length < 3;

    return (
      <Fragment>
        <SearchInputTextField
          color="primary"
          variant="outlined"
          fullWidth
          placeholder={t('common.search')}
          size="small"
          InputProps={{
            startAdornment: (
              <Box display="flex" alignItems="center" justifyContent="center" width="60px">
                {spinner ? <CircularProgress size={16} /> : <SearchIcon color="disabled" />}
              </Box>
            ),
            endAdornment: (
              <Box display="flex">
                <Tooltip title={<Fragment>{t('addcontent.searchByName')}</Fragment>} arrow>
                  <SearchInputButton
                    active={searchBy === SearchByEnum.NAME ? 1 : 0}
                    onClick={onSearchByChange(SearchByEnum.NAME)}
                  >
                    <Box fontSize="9px" lineHeight="10px" fontWeight="700">
                      {t('addcontent.headers.system.name')}
                    </Box>
                  </SearchInputButton>
                </Tooltip>
                <Tooltip title={<Fragment>{t('addcontent.searchByCodeName')}</Fragment>} arrow placement="bottom-end">
                  <SearchInputButton
                    active={searchBy === SearchByEnum.CODE_NAME ? 1 : 0}
                    onClick={onSearchByChange(SearchByEnum.CODE_NAME)}
                  >
                    <Box fontSize="9px" lineHeight="10px" fontWeight="700">
                      {t('addcontent.headers.system.codename')}
                    </Box>
                  </SearchInputButton>
                </Tooltip>
              </Box>
            ),
          }}
          onChange={onChange}
          value={value}
          error={error}
          helperText={error && t('errormessage.general.searcherror')}
        />
      </Fragment>
    );
  }
}

export default withTranslation()(AddManyContentSearch);
